import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Instagram } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const {
    items,
    openCart
  } = useCartStore();
  const cartItemsCount = items.reduce((sum, item) => sum + item.quantity, 0);
  return <header className="fixed top-0 left-0 right-0 z-40 bg-brand-bg/80 backdrop-blur-xl border-b border-brand-primary/5 transition-all duration-300" data-id="element-31" data-mp="2ni7kvo10jzo2">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center" data-id="element-32" data-mp="2wk72oijur7s2">
        <Link to="/" className="text-2xl font-serif font-semibold tracking-tight flex items-center hover:opacity-70 transition-opacity text-brand-primary" data-id="element-33" data-mp="31bp395hyr6ci">
          MyPlaner<span className="text-brand-accent" data-id="element-34" data-mp="3baxsjl1vvwsj">.</span>
        </Link>

        <div className="flex items-center gap-6" data-id="element-35" data-mp="3fbq2kgiky5pv">
          <a href="https://www.instagram.com/myplaner.ua/p/DXq4XE3jJA8/" target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center gap-2 text-brand-muted font-medium hover:text-brand-primary transition-colors text-sm" data-id="element-36" data-mp="3fcjcfqcu5bc8">
            <Instagram className="w-4 h-4" data-id="element-37" data-mp="2mng9v5g4pej9" />
            <span data-id="element-38" data-mp="2hnlhexgpggw3">@myplaner.ua</span>
          </a>

          <button onClick={openCart} className="relative flex items-center justify-center p-2.5 text-brand-primary hover:bg-brand-surfaceAlt rounded-full transition-colors" data-id="element-39" data-mp="2hovhttb1615w">
            <ShoppingCart className="w-5 h-5" strokeWidth={1.5} data-id="element-40" data-mp="3acrbep5azcyg" />
            <AnimatePresence data-id="element-41" data-mp="35kr6sjeafvvj">
              {cartItemsCount > 0 && <motion.span initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} exit={{
              scale: 0
            }} className="absolute top-0 right-0 bg-brand-accent text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full shadow-sm" data-id="element-42" data-mp="30mfv034fnbao">
                  {cartItemsCount}
                </motion.span>}
            </AnimatePresence>
          </button>
        </div>
      </div>
    </header>;
}